import { cn } from 'noddi-ui-common';
import { NoddiBasicCard } from 'noddi-ui-web';
import React from 'react';

interface Props {
  children: React.ReactNode;
  className?: string;
}

// Shared card used for transition screens and builders
export const TransitionCard = ({ children, className }: Props) => {
  return (
    <NoddiBasicCard
      className={cn(
        'flex w-full max-w-md flex-col items-center p-10 text-center',
        'animate-in fade-in-0 zoom-in-95',
        className
      )}
    >
      {children}
    </NoddiBasicCard>
  );
};
